<template>
  <div>
    <h2>Started 上手</h2>
    <h3>引入 vue-form-layer</h3>
    <vue-markdown v-highlight :source="content"></vue-markdown>
    <h3>开始使用</h3>
    <p>现在就可以编写代码了。</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: `
    import VueFormLayer from 'vue-form-layer'

    Vue.use(VueFormLayer)
      `
    };
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/started.vue